/**
 * Web addresses as links, everything else as the text it is. Only http(s): anything else a person pastes stays plain,
 * so a description can never carry a `javascript:` link. A trailing full stop or bracket belongs to the sentence.
 */
const URL = /(https?:\/\/[^\s<>"']*[^\s<>"'.,;:!?)\]])/g;

export function LinkifiedText({ text }: { text: string }) {
  // `split` with a capturing group alternates text and matches, so every odd part is an address.
  return <>{text.split(URL).map((part, i) => (i % 2
    ? <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="text-ink underline underline-offset-2 break-all">{part}</a>
    : part))}</>;
}
